import { useContext } from 'react'
import { RosterSetupContext } from '../RosterSetup'
import { characterRoles } from 'app/frontend/types/custom/CharacterRole'
import CharacterRoleIcon from 'app/frontend/base/components/CharacterRoleIcon'
import capitalize from 'lodash/capitalize'
import { cn } from '@/lib/utils'
import Card from 'app/frontend/base/components/Card'

const CountByRole = ({ className }: { className?: string }) => {
  const { mainsByRole, altsByRole, offSpecsByRole } =
    useContext(RosterSetupContext)

  const mainCount = Object.values(mainsByRole).reduce(
    (acc, role) => acc + (role?.length ?? 0),
    0,
  )
  const altCount = Object.values(altsByRole).reduce(
    (acc, role) => acc + (role?.length ?? 0),
    0,
  )
  const offCount = Object.values(offSpecsByRole).reduce(
    (acc, role) => acc + (role?.length ?? 0),
    0,
  )

  return (
    <Card className={cn('w-full grow', className)} size='sm'>
      <table className='w-full'>
        <thead>
          <tr className='[&>th]:px-2 [&>th:first-child]:pl-0 [&>th]:font-normal [&>th]:text-xs'>
            <th className='text-left'>Role</th>
            <th>Main</th>
            <th>Alt</th>
            <th>Off</th>
            <th>#</th>
          </tr>
        </thead>
        <tbody>
          {characterRoles.map((role) => {
            const mainCount = mainsByRole[role]?.length ?? 0
            const altCount = altsByRole[role]?.length ?? 0
            const offCount = offSpecsByRole[role]?.length ?? 0
            const totalCount = mainCount + altCount + offCount

            return (
              <tr key={role} className='border-t'>
                <td>
                  <div
                    className={`flex items-center gap-1.5 mr-2 ${
                      mainCount > 0 ? '' : 'opacity-60 italic'
                    }`}
                  >
                    <CharacterRoleIcon role={role} size='small' />{' '}
                    {capitalize(role)}
                  </div>
                </td>
                <td className='text-center'>
                  {mainCount || <span className='opacity-30'>-</span>}
                </td>
                <td className='text-center'>
                  {altCount || <span className='opacity-30'>-</span>}
                </td>
                <td className='text-center'>
                  {offCount || <span className='opacity-30'>-</span>}
                </td>
                <td className='text-center font-semibold'>
                  {totalCount || <span className='opacity-30'>-</span>}
                </td>
              </tr>
            )
          })}

          <tr className='border-t border-accent font-semibold'>
            <td></td>
            <td className='text-center'>
              {mainCount || <span className='opacity-30'>-</span>}
            </td>
            <td className='text-center'>
              {altCount || <span className='opacity-30'>-</span>}
            </td>
            <td className='text-center'>
              {offCount || <span className='opacity-30'>-</span>}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </Card>
  )
}

export default CountByRole
